import type { ComponentProps, ReactElement } from 'react'
import { cloneElement, isValidElement } from 'react'

import { clsx } from 'clsx'

export type IconProps = ComponentProps<'svg'>

export const Icon = (props: IconProps) => {
  const { children, className, ...rest } = props

  return isValidElement(children) ? (
    cloneElement(children as ReactElement, {
      'aria-hidden': true,
      focusable: false,
      className: clsx(className, children?.props?.className),
      ...rest,
    })
  ) : (
    <>{children}</>
  )
}
